import React, { FC } from 'react'

import { Box } from '@material-ui/core'

import Loader from './Loader'
import Text from './Text'

type Props = {
  length?: number
  loading?: boolean
  empty?: any
}

const LoaderBox: FC<Props> = ({
  loading,
  length,
  children,
  empty = 'No data'
}) => {
  return (
    <>
      {!length && (loading || !length) && (
        <>
          {loading ? (
            <Loader size={80} minHeight={200} />
          ) : (
            <Box
              width="100%"
              height="100%"
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              minHeight={200}
              color="text.secondary"
            >
              <Text color="textSecondary" fontSize={22}>
                {empty}
              </Text>
            </Box>
          )}
        </>
      )}
      {!!length && children}
    </>
  )
}

export default LoaderBox
